/** MXN amount for the quoter admin screens ("$1,000,000"; cents only when present). */
export const formatMxn = (amount: number): string =>
  amount.toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    maximumFractionDigits: 2,
  });

/**
 * A calendar date `YYYY-MM-DD` (no time zone: the day never shifts) as
 * "12 oct 2026" (`long` spells the month out: "12 de octubre de 2026").
 */
export const formatIsoDate = (
  isoDate: string,
  style: "medium" | "long" = "medium",
): string =>
  new Date(`${isoDate}T12:00:00Z`).toLocaleDateString("es-MX", {
    dateStyle: style,
    timeZone: "UTC",
  });

/** A date-time for the audit log, in the business time zone. */
export const formatWhen = (iso: string): string =>
  new Date(iso).toLocaleString("es-MX", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: "America/Mexico_City",
  });
